import { VStack, VStackTypes } from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';

import { SkeletonDesktop } from './desktop';
import { SkeletonMobile } from './mobile';
import { SkeletonTablet } from './tablet';

interface SkeletonProps extends VStackTypes.Props {
  itemsCount?: number;
}

export const Skeleton: React.FC<SkeletonProps> = ({ itemsCount = 1, ...rest }) => {
  const skeleton = useBreakpointValue({
    base: <SkeletonMobile />,
    sm: <SkeletonTablet />,
    lg: <SkeletonDesktop />,
  });

  const data = Array.from({ length: itemsCount }, (_, i) => i);

  return (
    <VStack space="inline.quarck" paddingBottom="inset.nano" {...rest}>
      {data.map((item) => (
        <Box key={item.toString()}>{skeleton}</Box>
      ))}
    </VStack>
  );
};
